import { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material';
import Page from '../components/Page';
import { adminApi } from 'src/utils/adminApi';

export default function ClutchRolePermissions() {
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi
      .listRoles()
      .then((result) => {
        const items = result.data?.items || [];
        setRoles(items);
        if (items[0]?.id) {
          setRoleId(String(items[0].id));
        }
      })
      .catch((err) => setError(err.message));
  }, []);

  useEffect(() => {
    if (!roleId) {
      return;
    }

    adminApi
      .rolePermissions(roleId)
      .then((result) => setPermissions(result.data?.permissions || []))
      .catch((err) => setError(err.message));
  }, [roleId]);

  return (
    <Page title={`Role Permissions | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="lg">
        <Box sx={{ py: 3 }}>
          <Typography variant="h4" sx={{ color: '#F3F4F6', mb: 3 }}>
            Role Permissions
          </Typography>
          {error && <Typography sx={{ color: '#F87171', mb: 2 }}>{error}</Typography>}

          <FormControl fullWidth sx={{ mb: 3, maxWidth: 360 }}>
            <InputLabel>Role</InputLabel>
            <Select label="Role" value={roleId} onChange={(e) => setRoleId(e.target.value)}>
              {roles.map((role) => (
                <MenuItem key={role.id} value={String(role.id)}>
                  {role.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Card sx={{ bgcolor: '#151921', border: '1px solid #232935', p: 2 }}>
            <Stack spacing={1}>
              {permissions.length === 0 && (
                <Typography sx={{ color: '#9CA3AF' }}>No permissions assigned.</Typography>
              )}
              {permissions.map((permission) => (
                <Typography key={permission.id || permission.slug} sx={{ color: '#F3F4F6' }}>
                  {permission.name || permission.slug}
                </Typography>
              ))}
            </Stack>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
